export const translations = {
  pl: {
    nav: {
      howItWorks: "Jak to działa",
      symbols: "Symbolika",
      symbolFinder: "Szukaj",
      pricing: "Konto",
      faq: "FAQ",
      signIn: "Zaloguj",
      profile: "Profil",
      signOut: "Wyloguj",
      dreams: "Sny",
      pokoik: "Pokoik",
      strefa: "Strefa",
      menu: "Menu",
      close: "Zamknij",
    },
    auth: {
      eyebrow: "Senna brama",
      loginTitlePre: "Wróć do swojej",
      loginTitleAccent: "Księgi Snów",
      loginSubtitle: "Otwórz prywatną kronikę. Twoje sny czekają, gdzie je zostawiłeś.",
      registerTitlePre: "Otwórz",
      registerTitleAccent: "Księgę Snów",
      registerSubtitle: "Załóż konto i zacznij prowadzić własną kronikę nocnych wizji.",
      email: "Email",
      password: "Hasło",
      passwordConfirm: "Powtórz hasło",
      displayName: "Twoja ksywka",
      displayNamePlaceholder: "Śniący",
      displayNameHint: "Możesz zostawić puste — uzupełnimy z emaila.",
      submitLogin: "Zaloguj się",
      submitRegister: "Załóż konto",
      loading: "Otwieram bramę…",
      haveAccount: "Masz już konto?",
      noAccount: "Nie masz konta?",
      signUpLink: "Załóż konto",
      signInLink: "Zaloguj się",
      mockNotice:
        "Tryb demo — konta zapisywane lokalnie w przeglądarce. Prawdziwy backend (FastAPI lub WordPress) doczepimy w kolejnym kroku.",
      errors: {
        required: "To pole jest wymagane.",
        invalidEmail: "Nieprawidłowy email.",
        passwordTooShort: "Hasło musi mieć co najmniej 6 znaków.",
        passwordMismatch: "Hasła nie są identyczne.",
        userNotFound: "Nie znaleziono konta dla tego adresu email.",
        wrongPassword: "Nieprawidłowe hasło.",
        emailTaken: "Email jest już zajęty.",
      },
    },
    profile: {
      eyebrow: "Twój zakątek",
      titlePre: "Witaj,",
      subtitle: "Twoja prywatna nisza w Morfeuszu. Stąd dotrzesz do snów, sejfu i ustawień.",
      accountTitle: "Konto",
      email: "Email",
      displayName: "Ksywka",
      memberSince: "Konto założone",
      dreamsCount: "Zapisanych snów",
      tier: "Plan",
      editDisplayName: "Zmień",
      save: "Zapisz",
      cancel: "Anuluj",
      logout: "Wyloguj się",
      backToRoom: "Pokoik",
      myDreams: "Moje sny",
    },
    symbolFinder: {
      eyebrow: "Atlas",
      titlePre: "Wyszukaj",
      titleAccent: "symbol",
      subtitle: "Wpisz symbol ze snu — wyrocznia odczyta jego znaczenie z biblioteki.",
      fieldLabel: "Symbol",
      placeholder: "np. księżyc, woda, klucz...",
      submit: "Odczytaj znaczenie",
      loading: "Wyrocznia szuka…",
      resultLabel: "Znaczenie",
      notFound: "Nie znaleziono w słowniku — spróbuj innego symbolu lub zapisz swoje skojarzenia.",
      notFoundHint: "Symbol jeszcze nie ma wpisu — zostanie dodany do biblioteki.",
      suggestionsTitle: "Popularne symbole",
      networkError: "Błąd połączenia z wyrocznią. Spróbuj za chwilę.",
    },
    hero: {
      eyebrow: "Senna Wyrocznia · Est. MMXXVI",
      title: "Zinterpretuj",
      titleAccent: "swój sen",
      subtitle:
        "Powierz nocne wizje cyfrowemu Morfeuszowi. Otrzymasz odczyt symboliki, archetypów i ukrytych nurtów psychiki — pisany językiem starych ksiąg.",
      placeholder:
        "Opisz sen jak najwierniej... Co widziałeś? Kto był obecny? Jaki towarzyszył nastrój?",
      submit: "Zinterpretuj sen",
      loading: "Wyrocznia czyta...",
      hint: "Anonimowo · bez rejestracji · interpretacja w kilka sekund",
      revealedEyebrow: "Sen, który otworzył bramę",
      revealedNote: "Ten darmowy odczyt został już odsłonięty. Kolejne sny możesz zapisywać w swojej prywatnej Księdze Snów po założeniu konta.",
      guestError: "Nie udało się wykonać darmowej interpretacji.",
    },
    interpretation: {
      title: "Odczyt Wyroczni",
      subtitle: "Wstępna interpretacja",
      symbolsTitle: "Rozpoznane symbole",
      readingTitle: "Tekst odczytu",
      mockBody:
        "W tym śnie wyłaniają się archetypy progu i przemiany. Woda, którą widzisz, niesie znaczenie nieświadomości — głębokich nurtów emocji, które domagają się uwagi. Postać towarzysząca może być cieniem, częścią ciebie, której jeszcze nie poznałeś. Powtarzający się motyw drogi sugeruje rozdroże w jawie: wybór między bezpieczeństwem znanego, a wezwaniem ku temu, co dopiero ma się ujawnić.",
      mockTags: ["Woda", "Próg", "Cień", "Droga", "Księżyc", "Przemiana"],
      saveCta: "Zapisz w swojej Księdze Snów",
      saveHint: "Wymaga konta — odblokuj historię, trendy i głębsze odczyty.",
      newDream: "Inny sen",
      mockedNotice: "Tryb demonstracyjny — pełna analiza GPT po integracji.",
      guestCtaEyebrow: "To dopiero pierwszy szept",
      guestCtaTitle: "Nie pozwól, by ten sen zniknął o świcie",
      guestCtaBody: "Darmowy odczyt Morfeusza otwiera się tylko raz — jak pierwsza karta wyciągnięta z talii. Załóż bezpłatne konto, aby zachować interpretację, zapisywać kolejne sny i odkrywać symbole, które mogą powracać noc po nocy.",
      guestCtaButton: "Załóż bezpłatne konto",
      guestCtaHint: "Księga Snów zapamięta odczyty, symbole i kolejne ślady Twojej nocnej opowieści.",
    },
    howItWorks: {
      eyebrow: "Trzy kroki",
      title: "Jak czyta Morfeusz",
      steps: [
        {
          title: "Powierz sen",
          desc: "Opisz wizję własnymi słowami — fragmenty, obrazy, uczucia. Im więcej szczegółów, tym pełniejszy odczyt.",
        },
        {
          title: "Wyrocznia odczytuje",
          desc: "Algorytm trenowany na tradycji onirokrytyki rozpoznaje symbole, archetypy i wzorce emocjonalne.",
        },
        {
          title: "Otrzymujesz odczyt",
          desc: "Czytelny tekst wraz z mapą symboliki — gotowy do refleksji, zapisu lub porównania z innymi snami.",
        },
      ],
    },
    symbols: {
      eyebrow: "Atlas symboli",
      title: "Słownik nocnych obrazów",
      subtitle:
        "Każdy symbol nosi ciężar tradycji. Oto fragment rosnącej biblioteki znaczeń.",
      items: [
        { name: "Księżyc", meaning: "Nieświadomość, cykle, intuicja kobieca." },
        { name: "Woda", meaning: "Emocje, oczyszczenie, nurt życia." },
        { name: "Klucz", meaning: "Wiedza tajemna, przejście, władza nad progiem." },
        { name: "Wąż", meaning: "Przemiana, mądrość, uzdrowienie i pokusa." },
        { name: "Dom", meaning: "Psyche, struktura jaźni, tożsamość." },
        { name: "Ptak", meaning: "Posłannictwo, wolność, dusza w locie." },
      ],
    },
    testimonials: {
      eyebrow: "Głosy śniących",
      title: "Co mówią o Morfeuszu",
      items: [
        {
          quote:
            "Po pierwszym odczycie zrozumiałam, dlaczego ten sam sen wracał do mnie od miesięcy. Czyste objawienie.",
          author: "Helena K.",
          role: "Warszawa",
        },
        {
          quote:
            "Język interpretacji jest poetycki, ale nie pusty. Wyciąga z głębi rzeczy, których nie umiałem nazwać.",
          author: "Tomasz B.",
          role: "Kraków",
        },
        {
          quote:
            "Zapisuję sny od pół roku. Mapa powtarzających się symboli zmieniła moje rozumienie własnego umysłu.",
          author: "Aleksandra M.",
          role: "Gdańsk",
        },
      ],
    },
    pricing: {
      eyebrow: "Księga Snów",
      title: "Załóż swoją własną kronikę",
      subtitle:
        "Darmowy odczyt zawsze pozostanie tutaj. Konto otwiera drzwi do pamięci, wzorców i głębszych warstw.",
      benefits: [
        "Prywatna baza wszystkich snów i odczytów",
        "Dostęp do mocniejszego modelu interpretacji",
        "Analiza trendów i nawracających symboli",
        "Eksport, znaczniki, notatki własne",
      ],
      cta: "Załóż konto wkrótce",
      ctaHint: "Wczesny dostęp · ceny ogłoszone wkrótce",
    },
    faq: {
      eyebrow: "Wątpliwości",
      title: "Pytania śniących",
      items: [
        {
          q: "Czy moje sny są prywatne?",
          a: "Tak. Anonimowe odczyty na stronie głównej nie są zapisywane. Konto przechowuje sny wyłącznie dla ciebie — szyfrowane na poziomie bazy.",
        },
        {
          q: "Czy interpretacja jest naukowa?",
          a: "Czerpiemy z tradycji onirokrytyki, psychologii głębi i analizy archetypowej. To narzędzie refleksji, nie diagnozy medycznej.",
        },
        {
          q: "Co dostanę po założeniu konta?",
          a: "Prywatną Księgę Snów, mocniejszy model interpretacji, mapę nawracających symboli i analizę trendów emocjonalnych w czasie.",
        },
        {
          q: "Czy aplikacja działa po angielsku?",
          a: "Tak. Przełącznik PL / EN znajduje się w nagłówku (na komórce w menu hamburgerowym). Modele interpretacji działają w obu językach.",
        },
      ],
    },
    footer: {
      tagline: "Cyfrowa wyrocznia snów",
      copyright: "© MMXXVI Morfeusz Dreams · Wszystkie wizje zastrzeżone",
      links: ["Polityka prywatności", "Regulamin", "Kontakt"],
    },
  },
  en: {
    nav: {
      howItWorks: "How it works",
      symbols: "Symbolism",
      symbolFinder: "Search",
      pricing: "Account",
      faq: "FAQ",
      signIn: "Sign in",
      profile: "Profile",
      signOut: "Sign out",
      dreams: "Dreams",
      pokoik: "Room",
      strefa: "Zone",
      menu: "Menu",
      close: "Close",
    },
    auth: {
      eyebrow: "Dream gate",
      loginTitlePre: "Return to your",
      loginTitleAccent: "Dream Codex",
      loginSubtitle: "Open your private chronicle. Your dreams are waiting where you left them.",
      registerTitlePre: "Open the",
      registerTitleAccent: "Dream Codex",
      registerSubtitle: "Create an account and begin keeping your own chronicle of nocturnal visions.",
      email: "Email",
      password: "Password",
      passwordConfirm: "Confirm password",
      displayName: "Your handle",
      displayNamePlaceholder: "Dreamer",
      displayNameHint: "You may leave it blank — we will derive one from your email.",
      submitLogin: "Sign in",
      submitRegister: "Create account",
      loading: "Opening the gate…",
      haveAccount: "Already have an account?",
      noAccount: "No account yet?",
      signUpLink: "Create one",
      signInLink: "Sign in",
      mockNotice:
        "Demo mode — accounts are stored locally in your browser. The real backend (FastAPI or WordPress) will be wired in next.",
      errors: {
        required: "This field is required.",
        invalidEmail: "Invalid email.",
        passwordTooShort: "Password must be at least 6 characters.",
        passwordMismatch: "Passwords do not match.",
        userNotFound: "No account found for this email.",
        wrongPassword: "Incorrect password.",
        emailTaken: "This email is already taken.",
      },
    },
    profile: {
      eyebrow: "Your nook",
      titlePre: "Welcome,",
      subtitle: "Your private corner of Morpheus. From here you reach the dreams, the vault and your settings.",
      accountTitle: "Account",
      email: "Email",
      displayName: "Handle",
      memberSince: "Member since",
      dreamsCount: "Saved dreams",
      tier: "Plan",
      editDisplayName: "Edit",
      save: "Save",
      cancel: "Cancel",
      logout: "Sign out",
      backToRoom: "Room",
      myDreams: "My dreams",
    },
    symbolFinder: {
      eyebrow: "Atlas",
      titlePre: "Search a",
      titleAccent: "symbol",
      subtitle: "Type a symbol from your dream — the oracle will read its meaning from the library.",
      fieldLabel: "Symbol",
      placeholder: "e.g. moon, water, key...",
      submit: "Read meaning",
      loading: "The oracle searches…",
      resultLabel: "Meaning",
      notFound: "Not in the dictionary yet — try another symbol or note your own associations.",
      notFoundHint: "This symbol has no entry yet — it will be added to the library.",
      suggestionsTitle: "Popular symbols",
      networkError: "Connection to the oracle failed. Try again in a moment.",
    },
    hero: {
      eyebrow: "Dream Oracle · Est. MMXXVI",
      title: "Interpret",
      titleAccent: "your dream",
      subtitle:
        "Entrust your nocturnal visions to digital Morpheus. You will receive a reading of symbols, archetypes and the hidden currents of the psyche — written in the language of old grimoires.",
      placeholder:
        "Describe the dream as faithfully as possible... What did you see? Who was present? What mood accompanied it?",
      submit: "Interpret dream",
      loading: "The oracle reads...",
      hint: "Anonymous · no signup · interpretation in seconds",
      revealedEyebrow: "The dream that opened the gate",
      revealedNote: "This free reading has already been unveiled. You can save your next dreams in your private Dream Codex after creating an account.",
      guestError: "The free interpretation could not be completed.",
    },
    interpretation: {
      title: "Oracle's Reading",
      subtitle: "Initial interpretation",
      symbolsTitle: "Recognized symbols",
      readingTitle: "Reading body",
      mockBody:
        "In this dream the archetypes of the threshold and transformation emerge. The water you see carries the meaning of the unconscious — deep currents of emotion that demand attention. The accompanying figure may be the shadow, a part of you not yet known. The recurring motif of the road suggests a crossroad in waking life: a choice between the safety of the familiar and a call towards what is yet to reveal itself.",
      mockTags: ["Water", "Threshold", "Shadow", "Path", "Moon", "Transformation"],
      saveCta: "Save to your Dream Codex",
      saveHint: "Requires account — unlock history, trends and deeper readings.",
      newDream: "Another dream",
      mockedNotice: "Demo mode — full GPT analysis after integration.",
      guestCtaEyebrow: "This is only the first whisper",
      guestCtaTitle: "Do not let this dream vanish at dawn",
      guestCtaBody: "Morpheus opens the free reading only once — like the first card drawn from a deck. Create a free account to keep this interpretation, save future dreams and discover symbols that may return night after night.",
      guestCtaButton: "Create a free account",
      guestCtaHint: "The Dream Codex remembers readings, symbols and the next traces of your nocturnal story.",
    },
    howItWorks: {
      eyebrow: "Three steps",
      title: "How Morpheus reads",
      steps: [
        {
          title: "Confide the dream",
          desc: "Describe the vision in your own words — fragments, images, feelings. The more detail, the fuller the reading.",
        },
        {
          title: "Oracle reads it",
          desc: "An algorithm trained on the oneirocritic tradition recognizes symbols, archetypes and emotional patterns.",
        },
        {
          title: "Receive the reading",
          desc: "A clear text alongside a map of symbols — ready for reflection, saving or comparison with other dreams.",
        },
      ],
    },
    symbols: {
      eyebrow: "Symbol atlas",
      title: "Dictionary of nocturnal images",
      subtitle:
        "Each symbol carries the weight of tradition. A fragment of a growing library of meanings.",
      items: [
        { name: "Moon", meaning: "Unconscious, cycles, feminine intuition." },
        { name: "Water", meaning: "Emotion, purification, the current of life." },
        { name: "Key", meaning: "Hidden knowledge, passage, power over the threshold." },
        { name: "Serpent", meaning: "Transformation, wisdom, healing and temptation." },
        { name: "House", meaning: "Psyche, structure of the self, identity." },
        { name: "Bird", meaning: "Messenger, freedom, soul in flight." },
      ],
    },
    testimonials: {
      eyebrow: "Voices of dreamers",
      title: "What they say about Morpheus",
      items: [
        {
          quote:
            "After the first reading I understood why this same dream had been returning for months. Pure revelation.",
          author: "Helena K.",
          role: "Warsaw",
        },
        {
          quote:
            "The language of the interpretation is poetic, but not empty. It draws out from the depths things I could not name.",
          author: "Tomasz B.",
          role: "Krakow",
        },
        {
          quote:
            "I have been logging dreams for half a year. The map of recurring symbols has changed how I understand my own mind.",
          author: "Aleksandra M.",
          role: "Gdansk",
        },
      ],
    },
    pricing: {
      eyebrow: "Dream Codex",
      title: "Open your own chronicle",
      subtitle:
        "The free reading will always remain here. An account opens the door to memory, patterns and deeper layers.",
      benefits: [
        "Private archive of all dreams and readings",
        "Access to a stronger interpretation model",
        "Analysis of trends and recurring symbols",
        "Export, tags, personal notes",
      ],
      cta: "Sign up — coming soon",
      ctaHint: "Early access · pricing announced soon",
    },
    faq: {
      eyebrow: "Doubts",
      title: "Dreamer's questions",
      items: [
        {
          q: "Are my dreams private?",
          a: "Yes. Anonymous readings on the home page are not stored. An account keeps your dreams for you only — encrypted at the database level.",
        },
        {
          q: "Is the interpretation scientific?",
          a: "We draw from the oneirocritic tradition, depth psychology and archetypal analysis. It is a tool for reflection, not a medical diagnosis.",
        },
        {
          q: "What do I get after signing up?",
          a: "A private Dream Codex, a stronger interpretation model, a map of recurring symbols and an analysis of emotional trends over time.",
        },
        {
          q: "Does the app work in English?",
          a: "Yes. The PL / EN switch sits in the header (inside the hamburger menu on mobile). Interpretation models work in both languages.",
        },
      ],
    },
    footer: {
      tagline: "A digital oracle of dreams",
      copyright: "© MMXXVI Morfeusz Dreams · All visions reserved",
      links: ["Privacy", "Terms", "Contact"],
    },
  },
};
